<script lang="ts">
export default defineNuxtComponent({
    props: {
        level: String,
    },
    setup(props, { slots, attrs }) {
        // Pass attrs (class, tabindex, etc.) to the heading element
        return () => h(props.level as string, attrs, (slots.default as Function)())
    },
})
</script>
